import { render } from "./previewImages.vue?vue&type=template&id=3f000134&scoped=true"
import script from "./previewImages.vue?vue&type=script&lang=js"
export * from "./previewImages.vue?vue&type=script&lang=js"

import "./previewImages.vue?vue&type=style&index=0&id=3f000134&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f000134"

export default script